import { useApiClient } from '../../api/useApiClient';

/**
 * Servicio para la integración de Telegram (pairing, listado y revocación de bindings).
 * Endpoints bajo /api/v1/integrations/telegram/* — ver FSD-001 REQ-015 y ADR-013.
 */
class TelegramIntegrationService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Genera un link de pairing para vincular el chat de Telegram del usuario.
     * @returns {Promise<{data: {deepLinkUrl: string, expiresAt: string}}>}
     */
    async initiatePairing() {
        return this.apiClient.post('/api/v1/integrations/telegram/initiate', {});
    }

    /**
     * Lista los chats de Telegram vinculados del usuario autenticado.
     * @returns {Promise<{data: Array<{id, telegramChatId, telegramUserId, telegramUsername, createdAt, lastSeenAt}>}>}
     */
    async listBindings() {
        return this.apiClient.get('/api/v1/integrations/telegram/bindings');
    }

    /**
     * Revoca un chat de Telegram vinculado (del propio usuario).
     * @param {number} idBinding
     * @returns {Promise<{data: {success, message, id}}>}
     */
    async removeBinding(idBinding) {
        return this.apiClient.delete(`/api/v1/integrations/telegram/bindings/${idBinding}`);
    }
}

export const useTelegramIntegrationService = () => {
    const apiClient = useApiClient();
    return new TelegramIntegrationService(apiClient);
};

export default TelegramIntegrationService;
